const Steps = [
    // miscellaneous
    { 
        index: 0,
        category: 'miscellaneous', 
        name: 'comment', 
        icon: 'tag', 
        title: 'Comment', 
        ignore: true,
        output: {
        },
        options: {
        }
    },
    { 
        index: 0,
        category: 'miscellaneous', 
        name: 'setVariable', 
        icon: 'save', 
        title: 'Set Variable', 
        ignore: false,
        output: {
            icon: 'question_mark',
            key: '$variableName',
            value: ""
        },
        options: {
            value: {
                required: true,
                placeholder: '123',
                value: ""
            },
        },
    },
    // browser
    { 
        index: 0,
        category: 'browser', 
        name: 'openBrowser', 
        icon: 'web_asset', 
        title: 'Open Browser', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$browser',
            value: ""
        },
        options: {
            url: {
                required: true,
                placeholder: 'https://www.google.com/',
                value: ""
            },
            windowSize: {
                required: false,
                placeholder: '',
                value: "1280,1024"
            },
            language: {
                required: false,
                placeholder: '',
                value: "en"
            },
            basicAuthUsername: {
                required: false,
                placeholder: 'admin',
                value: ""
            },
            basicAuthPassword: {
                required: false,
                placeholder: '123456',
                value: ""
            },
            acceptDialog: {
                required: false,
                placeholder: '',
                value: true
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
        }
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'typeText', 
        icon: 'text_fields', 
        title: 'Type Text', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'input[name="q"]',
                value: ""
            },
            text: {
                required: true,
                placeholder: 'Goolge',
                value: ""
            },
            clearValue: {
                required: false,
                placeholder: '',
                value: true
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'typePassword', 
        icon: 'password', 
        title: 'Type Password', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'input[name="q"]',
                value: ""
            },
            passwords: {
                required: true,
                placeholder: '123456',
                value: ""
            },
            clearValue: {
                required: false,
                placeholder: '',
                value: true
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'click', 
        icon: 'ads_click', 
        title: 'Click', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'button[name="login"]',
                value: ""
            },
            waitForNavigation: {
                required: false,
                placeholder: '',
                value: true
            },
            acceptDialog: {
                required: false,
                placeholder: '',
                value: true
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'selectOption', 
        icon: 'checklist', 
        title: 'Select Option', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'select[name="gender"]',
                value: ""
            },
            text: {
                required: true,
                placeholder: 'male',
                value: ""
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'keyboardPress', 
        icon: 'keyboard_command_key', 
        title: 'Keyboard Press', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            keyboards: {
                required: true,
                placeholder: 'ArrowLeft, Enter',
                value: ""
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'downloadFile', 
        icon: 'file_download', 
        title: 'Download File', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$file',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            actionsForDownload: {
                required: true,
                placeholder: '',
                value: "click"
            },
            selector: {
                required: true,
                placeholder: 'div[name="download"]',
                value: ""
            },
            timeout: {
                required: false,
                placeholder: '180000',
                value: ""
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'uploadFile', 
        icon: 'file_upload', 
        title: 'Upload File', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'input[name="upfile"]',
                value: ""
            },
            filePath: {
                required: true,
                placeholder: '/tmp/file-upload.pdf',
                value: ""
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'getText', 
        icon: 'text_increase', 
        title: 'Get Text', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$text',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'div.banner > div > a',
                value: ""
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'clickPoint', 
        icon: 'my_location', 
        title: 'Click Point', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: false,
                placeholder: 'button[name="login"]',
                value: ""
            },
            coordinateX: {
                required: true,
                placeholder: '300',
                value: ""
            },
            coordinateY: {
                required: true,
                placeholder: '500',
                value: ""
            },
            waitForNavigation: {
                required: false,
                placeholder: '',
                value: true
            },
            acceptDialog: {
                required: false,
                placeholder: '',
                value: true
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'takeScreenshot', 
        icon: 'panorama', 
        title: 'Take Screenshot', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$screenshot',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            clip: {
                required: false,
                placeholder: '0,100,500,500',
                value: ""
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'pagePDF', 
        icon: 'picture_as_pdf', 
        title: 'Page PDF', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$pdf',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            format: {
                required: true,
                placeholder: '',
                value: "A4"
            },
            scale: {
                required: false,
                placeholder: '1.0',
                value: ""
            },
            pageRanges: {
                required: false,
                placeholder: '1-2,13-15,20,29',
                value: ""
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'hover', 
        icon: 'mouse', 
        title: 'Hover', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'div.banner > div > a',
                value: ""
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'scrapePage', 
        icon: 'list_alt', 
        title: 'Scrape Page', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$scrape',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'div.banner > div > a',
                value: ""
            },
            textOnly: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'extractDataFromTable', 
        icon: 'table', 
        title: 'Extract Data From Table', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$extractDataFromTable',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'div.exchange-rate-table',
                value: ""
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'findElement', 
        icon: 'manage_search', 
        title: 'Find Element', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$element',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            findElementBy: {
                required: true,
                placeholder: '',
                value: "text"
            },
            text: {
                required: true,
                placeholder: 'Goolge',
                value: ""
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'getURL', 
        icon: 'lock', 
        title: 'Get URL', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$url',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'getAttribute', 
        icon: 'font_download', 
        title: 'Get Attribute', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$attribute',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'img.logo',
                value: ""
            },
            attribute: {
                required: true,
                placeholder: 'src',
                value: ""
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'waitForSelector', 
        icon: 'hourglass_empty', 
        title: 'Wait For Selector', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            selector: {
                required: true,
                placeholder: 'div.banner-popup',
                value: ""
            },
            timeout: {
                required: false,
                placeholder: '180000',
                value: ""
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'dragAndDrop', 
        icon: 'move_down', 
        title: 'Drag And Drop', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            targetSelector: {
                required: true,
                placeholder: 'img#drag1',
                value: ""
            },
            destinationSelector: {
                required: true,
                placeholder: 'div#div2',
                value: ""
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
            ignoreError: {
                required: false,
                placeholder: '',
                value: true
            }
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'injectJavascript', 
        icon: 'javascript', 
        title: 'Inject Javascript', 
        ignore: false,
        output: {
            icon: 'question_mark',
            key: '$injectJavaScript',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            code: {
                required: true,
                placeholder: 'let x = 1; let y = 2; return x + y;',
                value: ""
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'goToUrl', 
        icon: 'open_in_browser', 
        title: 'Go To Url', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            url: {
                required: true,
                placeholder: 'https://www.google.com/',
                value: ""
            },
            acceptDialog: {
                required: false,
                placeholder: '',
                value: true
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'goBack', 
        icon: 'arrow_back', 
        title: 'Go Back', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'openNewTab', 
        icon: 'tab_group', 
        title: 'Open New Tab', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            url: {
                required: true,
                placeholder: 'https://www.google.com/',
                value: ""
            },
            acceptDialog: {
                required: false,
                placeholder: '',
                value: true
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'switchTab', 
        icon: 'tab', 
        title: 'Switch Tab', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            tab: {
                required: true,
                placeholder: '',
                value: "1"
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'showTabs', 
        icon: 'tab_unselected', 
        title: 'Show Tabs', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$tabs',
            value: ""
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'closeTab', 
        icon: 'tab_close', 
        title: 'Close Tab', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
            tab: {
                required: true,
                placeholder: '',
                value: "1"
            },
            screenshot: {
                required: false,
                placeholder: '',
                value: true
            },
        },
    },
    { 
        index: 0,
        category: 'browser', 
        name: 'closeBrowser', 
        icon: 'web_asset_off', 
        title: 'Close Browser', 
        ignore: false,
        output: {
        },
        options: {
            browser: {
                required: true,
                placeholder: '$browser_1',
                value: ""
            },
        },
    },
    // storages
    { 
        index: 0,
        category: 'storages', 
        name: 'listFiles', 
        icon: 'snippet_folder', 
        title: 'List Files', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$listFiles',
            value: ""
        },
        options: {
            directory: {
                required: true,
                placeholder: '/tmp/directory-name/',
                value: ""
            },
            fullPath: {
                required: false,
                placeholder: '',
                value: false
            },
        }
    },
    { 
        index: 0,
        category: 'storages', 
        name: 'renameFile', 
        icon: 'edit_document', 
        title: 'Rename File', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$renameFile',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.pdf',
                value: ""
            },
            fileName: {
                required: true,
                placeholder: 'new-file-name',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'storages', 
        name: 'moveFiles', 
        icon: 'drive_file_move', 
        title: 'Move Files', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$moveFiles',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.pdf',
                value: ""
            },
            directory: {
                required: true,
                placeholder: '/tmp/move-file-to/directory-name/',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'storages', 
        name: 'deleteFiles', 
        icon: 'folder_delete', 
        title: 'Delete Files', 
        ignore: false,
        output: {
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/delete-file-name.pdf',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'storages', 
        name: 'copyFiles', 
        icon: 'file_copy', 
        title: 'Copy Files', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$copyFiles',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.pdf',
                value: ""
            },
            directory: {
                required: true,
                placeholder: '/tmp/copy-file-to/directory-name/',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'storages', 
        name: 'compressFiles', 
        icon: 'folder_zip', 
        title: 'Compress Files', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$compressFiles',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.pdf',
                value: ""
            },
            fileName: {
                required: true,
                placeholder: 'compress-file-name (ZIP)',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'storages', 
        name: 'decompressFiles', 
        icon: 'folder_open', 
        title: 'Decompress Files', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$decompressFiles',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.zip',
                value: ""
            },
            encoding: {
                required: true,
                placeholder: '',
                value: "UTF-8"
            }
        }
    },
    // json
    { 
        index: 0,
        category: 'json', 
        name: 'createArray', 
        icon: 'data_array', 
        title: 'Create Array', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$array',
            value: ""
        },
        options: {
            array: {
                required: true,
                placeholder: '["red", "green", "blue"]',
                value: ""
            }
        }
    },
    { 
        index: 0,
        category: 'json', 
        name: 'getElementFromArray', 
        icon: 'format_list_numbered_rtl', 
        title: 'Get Element From Array', 
        ignore: false,
        output: {
            icon: 'question_mark',
            key: '$element',
            value: ""
        },
        options: {
            arrayData: {
                required: true,
                placeholder: '["red", "green", "blue"]',
                value: ""
            },
            arrayIndex: {
                required: true,
                placeholder: '0',
                value: ""
            }
        }
    },
    { 
        index: 0,
        category: 'json', 
        name: 'createObject', 
        icon: 'data_object', 
        title: 'Create Object', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$object',
            value: ""
        },
        options: {
            object: {
                required: true,
                placeholder: '{"product": "pen", "color": "blue"}',
                value: ""
            }
        }
    },
    { 
        index: 0,
        category: 'json', 
        name: 'getValueFromObject', 
        icon: 'format_list_bulleted', 
        title: 'Get Value From Object', 
        ignore: false,
        output: {
            icon: 'question_mark',
            key: '$value',
            value: ""
        },
        options: {
            objectData: {
                required: true,
                placeholder: '{"product": "pen", "color": "blue"}',
                value: ""
            },
            objectKey: {
                required: true,
                placeholder: 'product',
                value: ""
            }
        }
    },
    // text
    { 
        index: 0,
        category: 'text', 
        name: 'createText', 
        icon: 'format_size', 
        title: 'Create Text', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$text',
            value: ""
        },
        options: {
            text: {
                required: true,
                placeholder: 'The quick brown fox, jumps over the dog.',
                value: ""
            }
        }
    },
    { 
        index: 0,
        category: 'text', 
        name: 'splitText', 
        icon: 'cut', 
        title: 'Split Text', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$splitText',
            value: ""
        },
        options: {
            text: {
                required: true,
                placeholder: 'The quick brown fox, jumps over the dog.',
                value: ""
            },
            splitWith: {
                required: true,
                placeholder: ',',
                value: ""
            }
        }
    },
    { 
        index: 0,
        category: 'text', 
        name: 'replaceText', 
        icon: 'find_replace', 
        title: 'Replace Text', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$replaceText',
            value: ""
        },
        options: {
            text: {
                required: true,
                placeholder: 'The quick brown fox, jumps over the dog.',
                value: ""
            },
            find: {
                required: true,
                placeholder: 'dog',
                value: ""
            },
            replaceWith: {
                required: true,
                placeholder: 'monkey',
                value: ""
            }
        }
    },
    { 
        index: 0,
        category: 'text', 
        name: 'matchText', 
        icon: 'search', 
        title: 'Match Text', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$matchText',
            value: ""
        },
        options: {
            text: {
                required: true,
                placeholder: 'The quick brown fox, jumps over the dog.',
                value: ""
            },
            regexp: {
                required: true,
                placeholder: '([a-zA-Z])+',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'text', 
        name: 'readText', 
        icon: 'description', 
        title: 'Read Text', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$readText',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/delete-file-name.txt',
                value: ""
            },
            encoding: {
                required: true,
                placeholder: '',
                value: "UTF-8"
            }
        }
    },
    { 
        index: 0,
        category: 'text', 
        name: 'convertPdfToText', 
        icon: 'picture_as_pdf', 
        title: 'Convert PDF To Text', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$pdfToText',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/delete-file-name.pdf',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'text', 
        name: 'appendValueToTextFile', 
        icon: 'edit_document', 
        title: 'Append Value To Text File', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$textFile',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.text',
                value: ""
            },
            value: {
                required: true,
                placeholder: 'abc',
                value: ""
            },
            position: {
                required: true,
                placeholder: 'end',
                value: ""
            },
            encoding: {
                required: true,
                placeholder: '',
                value: "UTF-8"
            }
        }
    },
    // excel
    { 
        index: 0,
        category: 'excel', 
        name: 'createNewFile', 
        icon: 'note_add', 
        title: 'Create New File', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$newFileExcel',
            value: ""
        },
        options: {
            directory: {
                required: true,
                placeholder: '/tmp/directory-name/',
                value: ""
            },
            fileName: {
                required: true,
                placeholder: 'file-name.xlsx',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'getSheetNames', 
        icon: 'format_list_bulleted', 
        title: 'Get Sheet Names', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$sheetNames',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.xlsx',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'changeSheetName', 
        icon: 'published_with_changes', 
        title: 'Change Sheet Name', 
        ignore: false,
        output: {
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.xlsx',
                value: ""
            },
            sheetName: {
                required: true,
                placeholder: 'Sheet',
                value: ""
            },
            newSheetName: {
                required: true,
                placeholder: 'New sheet',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'selectSheet', 
        icon: 'grid_on', 
        title: 'Select Sheet', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$workSheet',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.xlsx',
                value: ""
            },
            sheetName: {
                required: true,
                placeholder: 'Sheet',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'readCell', 
        icon: 'font_download', 
        title: 'Read Cell', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$cellValue',
            value: ""
        },
        options: {
            workSheet: {
                required: true,
                placeholder: '$workSheet_1',
                value: ""
            },
            cellLabel: {
                required: true,
                placeholder: 'A1',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'writeCell', 
        icon: 'edit_square', 
        title: 'Write Cell', 
        ignore: false,
        output: {
        },
        options: {
            workSheet: {
                required: true,
                placeholder: '$workSheet_1',
                value: ""
            },
            cellLabel: {
                required: true,
                placeholder: 'A1',
                value: ""
            },
            value: {
                required: true,
                placeholder: 'abc',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'readRange', 
        icon: 'type_specimen', 
        title: 'Read Range', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$rangeValue',
            value: ""
        },
        options: {
            workSheet: {
                required: true,
                placeholder: '$workSheet_1',
                value: ""
            },
            range: {
                required: true,
                placeholder: 'A1:B10',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'writeRange', 
        icon: 'app_registration', 
        title: 'Write Range', 
        ignore: false,
        output: {
        },
        options: {
            workSheet: {
                required: true,
                placeholder: '$workSheet_1',
                value: ""
            },
            cellLabel: {
                required: true,
                placeholder: 'A1',
                value: ""
            },
            value: {
                required: true,
                placeholder: '[["No", "Product"], ["1", "Pen"], ["2", "Note"]]',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'deleteRange', 
        icon: 'backspace', 
        title: 'Delete Range', 
        ignore: false,
        output: {
        },
        options: {
            workSheet: {
                required: true,
                placeholder: '$workSheet_1',
                value: ""
            },
            range: {
                required: true,
                placeholder: 'A1:B10',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'convertExcelToCSV', 
        icon: 'restore_page', 
        title: 'Convert Excel To CSV', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$excelToCSV',
            value: ""
        },
        options: {
            workSheet: {
                required: true,
                placeholder: '$workSheet_1',
                value: ""
            },
            fileName: {
                required: true,
                placeholder: 'file-name.csv',
                value: ""
            },
            encoding: {
                required: false,
                placeholder: '',
                value: "UTF-8"
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'writeCSV', 
        icon: 'text_snippet', 
        title: 'Write CSV', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$newFileCSV',
            value: ""
        },
        options: {
            directory: {
                required: true,
                placeholder: '/tmp/directory-name/',
                value: ""
            },
            fileName: {
                required: true,
                placeholder: 'file-name.csv',
                value: ""
            },
            value: {
                required: true,
                placeholder: '[["No", "Product"], ["1", "Pen"], ["2", "Note"]]',
                value: ""
            },
            delimiter: {
                required: true,
                placeholder: ',',
                value: ","
            },
            encoding: {
                required: false,
                placeholder: '',
                value: "UTF-8"
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'readCSV', 
        icon: 'document_scanner', 
        title: 'Read CSV', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$readCSV',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.csv',
                value: ""
            },
            delimiter: {
                required: true,
                placeholder: ',',
                value: ","
            },
            headers: {
                required: false,
                placeholder: '',
                value: true
            },
            encoding: {
                required: false,
                placeholder: '',
                value: "UTF-8"
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'changeDelimiterCSVFile', 
        icon: 'published_with_changes', 
        title: 'Read CSV', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$changeDelimiterCsvFile',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.csv',
                value: ""
            },
            from: {
                required: true,
                placeholder: ';',
                value: ";"
            },
            to: {
                required: true,
                placeholder: ',',
                value: ","
            },
            encoding: {
                required: false,
                placeholder: '',
                value: "UTF-8"
            },
        }
    },
    { 
        index: 0,
        category: 'excel', 
        name: 'appendValueToCSVFile', 
        icon: 'post_add', 
        title: 'Append Value To CSV File', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$csvFile',
            value: ""
        },
        options: {
            filePath: {
                required: true,
                placeholder: '/tmp/file-name.csv',
                value: ""
            },
            value: {
                required: true,
                placeholder: '[["3", "Ruler"], ["4", "Eraser"]]',
                value: ""
            },
            position: {
                required: true,
                placeholder: 'end',
                value: ""
            },
            delimiter: {
                required: true,
                placeholder: ',',
                value: ","
            },
            encoding: {
                required: false,
                placeholder: '',
                value: "UTF-8"
            },
        }
    },
    // gmail
    { 
        index: 0,
        category: 'gmail', 
        name: 'sendGmail', 
        icon: 'send', 
        title: 'Send Gmail', 
        ignore: false,
        output: {
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'gmail-xxxxxxxxxxxxxx',
                value: ""
            },
            to: {
                required: true,
                placeholder: 'john.doe@example.com',
                value: ""
            },
            subject: {
                required: true,
                placeholder: 'Gmail subject',
                value: ""
            },
            body: {
                required: true,
                placeholder: 'Gmail body',
                value: ""
            },
            attachments: {
                required: false,
                placeholder: '/tmp/fileName.xlsx',
                value: ""
            },
            from: {
                required: false,
                placeholder: 'abc@example.com',
                value: ""
            },
            cc: {
                required: false,
                placeholder: 'jane.doe@example.com, richard.roe@example.com',
                value: ""
            },
            bcc: {
                required: false,
                placeholder: 'jane.doe@example.com, richard.roe@example.com',
                value: ""
            }
        }   
    },
    { 
        index: 0,
        category: 'gmail', 
        name: 'getGmail', 
        icon: 'mark_email_unread', 
        title: 'Get Gmail', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$gmailMessages',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'gmail-xxxxxxxxxxxxxx',
                value: ""
            },
            query: {
                required: true,
                placeholder: 'subject: Gmail subject',
                value: ""
            },
            limit: {
                required: true,
                placeholder: '1',
                value: ""
            },
            markAsRead: {
                required: true,
                placeholder: '',
                value: true
            },
        }
    },
    { 
        index: 0,
        category: 'gmail', 
        name: 'gmailDownloadAttachments', 
        icon: 'attach_email', 
        title: 'Gmail Download Attachments', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$gmailAttachments',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'gmail-xxxxxxxxxxxxxx',
                value: ""
            },
            gmailMessages: {
                required: true,
                placeholder: '$gmailMessages_1',
                value: ""
            },
        }
    },
    // calendar
    { 
        index: 0,
        category: 'calendar', 
        name: 'getCalendarEvents', 
        icon: 'calendar_month', 
        title: 'Get Calendar Events', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$calendarEvents',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'googlecalendar-xxxxxxxxxxxxxx',
                value: ""
            },
            calendarID: {
                required: true,
                placeholder: 'john.doe@example.com',
                value: ""
            },
            summary: {
                required: false,
                placeholder: 'Google calendar summary',
                value: ""
            },
            from: {
                required: true,
                placeholder: '2022-12-01T00:00:00+07:00',
                value: ""
            },
            to: {
                required: true,
                placeholder: '2022-12-31T23:59:59+07:00',
                value: ""
            },
            descriptions: {
                required: false,
                placeholder: 'Descriptions of event',
                value: ""
            },
            limit: {
                required: false,
                placeholder: '1',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'calendar', 
        name: 'createCalendarEvent', 
        icon: 'edit_calendar', 
        title: 'Create Calendar Event', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$newCalendarEvent',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'googlecalendar-xxxxxxxxxxxxxx',
                value: ""
            },
            summary: {
                required: true,
                placeholder: 'Google calendar summary',
                value: ""
            },
            from: {
                required: true,
                placeholder: '2022-12-01T00:00:00+07:00',
                value: ""
            },
            to: {
                required: true,
                placeholder: '2022-12-31T23:59:59+07:00',
                value: ""
            },
            attendees: {
                required: false,
                placeholder: 'john.doe@example.com',
                value: ""
            },
            descriptions: {
                required: false,
                placeholder: 'Descriptions of event',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'calendar', 
        name: 'removeCalendarEvent', 
        icon: 'event_busy', 
        title: 'Remove Calendar Event', 
        ignore: false,
        output: {
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'googlecalendar-xxxxxxxxxxxxxx',
                value: ""
            },
            eventID: {
                required: true,
                placeholder: 'gld9fnvnhi84o0s1np8gagtu68',
                value: ""
            },
        }
    },
    // drive
    { 
        index: 0,
        category: 'drive', 
        name: 'createDriveFile', 
        icon: 'add_to_drive', 
        title: 'Create Drive File', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$newDriveID',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'googledrive-xxxxxxxxxxxxxx',
                value: ""
            },
            filePath: {
                required: true,
                placeholder: '/tmp/fileName.pdf',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'drive', 
        name: 'getDriveFile', 
        icon: 'downloading', 
        title: 'Get Drive File', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$driveFile',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'googledrive-xxxxxxxxxxxxxx',
                value: ""
            },
            fileID: {
                required: true,
                placeholder: '1MaW_N9XOSkvq7F-y7J0JE5dhafAqjHfu',
                value: ""
            },
        }
    },
    // docs
    { 
        index: 0,
        category: 'docs', 
        name: 'createDocs', 
        icon: 'assignment_add', 
        title: 'Create Docs', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$newDocs',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'docs-xxxxxxxxxxxxxx',
                value: ""
            },
            title: {
                required: true,
                placeholder: 'Title of Document',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'docs', 
        name: 'getDocs', 
        icon: 'assignment', 
        title: 'Get Docs', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$docs',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'docs-xxxxxxxxxxxxxx',
                value: ""
            },
            documentID: {
                required: true,
                placeholder: '14GrI7pJl02KITqAozd7h1VzdN5mJpm5BXx_Q3fACyeY',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'docs', 
        name: 'docsInsertParagraph', 
        icon: 'note_alt', 
        title: 'Docs Insert Paragraph', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$docsInsertParagraph',
            value: ""
        },
        options: {
            document: {
                required: true,
                placeholder: '$docs_1',
                value: ""
            },
            text: {
                required: true,
                placeholder: 'Inser Paragraph',
                value: ""
            },
            index: {
                required: true,
                placeholder: '1',
                value: ""
            },
        }
    },
    // spreadsheet
    { 
        index: 0,
        category: 'spreadsheet', 
        name: 'createSpreadsheet', 
        icon: 'note_add', 
        title: 'Create Spreadsheet', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$newSpreadsheet',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'spreadsheets-xxxxxxxxxxxxxx',
                value: ""
            },
            title: {
                required: true,
                placeholder: 'Title of spreadsheets',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'spreadsheet', 
        name: 'getSpreadsheet', 
        icon: 'grid_on', 
        title: 'Get Spreadsheet', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$spreadsheet',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'spreadsheets-xxxxxxxxxxxxxx',
                value: ""
            },
            spreadsheetID: {
                required: true,
                placeholder: '1o99OEiRin5H8JZyomfn7UHaNFbE1fiPUQ1_PpWDEwv8',
                value: ""
            },
            sheetName: {
                required: true,
                placeholder: 'Sheet1',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'spreadsheet', 
        name: 'getValues', 
        icon: 'window', 
        title: 'Get Values', 
        ignore: false,
        output: {
            icon: 'data_array',
            key: '$spreadsheetValues',
            value: ""
        },
        options: {
            spreadsheet: {
                required: true,
                placeholder: '$spreadsheet_1',
                value: ""
            },
            range: {
                required: true,
                placeholder: 'A1:B10',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'spreadsheet', 
        name: 'updateValues', 
        icon: 'app_registration', 
        title: 'Update Values', 
        ignore: false,
        output: {
        },
        options: {
            spreadsheet: {
                required: true,
                placeholder: '$spreadsheet_1',
                value: ""
            },
            range: {
                required: true,
                placeholder: 'A1:B10',
                value: ""
            },
            value: {
                required: true,
                placeholder: '[["No", "Product"], ["1", "Pen"], ["2", "Note"]]',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'spreadsheet', 
        name: 'appendValues', 
        icon: 'apps', 
        title: 'Append Values', 
        ignore: false,
        output: {
        },
        options: {
            spreadsheet: {
                required: true,
                placeholder: '$spreadsheet_1',
                value: ""
            },
            range: {
                required: true,
                placeholder: 'A1:B10',
                value: ""
            },
            value: {
                required: true,
                placeholder: '[["No", "Product"], ["1", "Pen"], ["2", "Note"]]',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'spreadsheet', 
        name: 'clearValues', 
        icon: 'backspace', 
        title: 'Clear Values', 
        ignore: false,
        output: {
        },
        options: {
            spreadsheet: {
                required: true,
                placeholder: '$spreadsheet_1',
                value: ""
            },
            range: {
                required: true,
                placeholder: 'A1:B10',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'spreadsheet', 
        name: 'duplicateSheet', 
        icon: 'table_view', 
        title: 'Duplicate Sheet', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$duplicateSheet',
            value: ""
        },
        options: {
            spreadsheet: {
                required: true,
                placeholder: '$spreadsheet_1',
                value: ""
            },
            sheetName: {
                required: true,
                placeholder: 'Sheet1',
                value: ""
            },
            spreadsheetDestination: {
                required: true,
                placeholder: '$spreadsheet_2',
                value: ""
            },
            sheetNameDestination: {
                required: true,
                placeholder: 'Sheet2',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'spreadsheet', 
        name: 'downloadSheets', 
        icon: 'download_for_offline', 
        title: 'Download Sheets', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$downloadSheets',
            value: ""
        },
        options: {
            spreadsheet: {
                required: true,
                placeholder: '$spreadsheet_1',
                value: ""
            },
            sheetName: {
                required: false,
                placeholder: 'Sheet1',
                value: ""
            },
            extension: {
                required: true,
                placeholder: 'xlsx',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'spreadsheet', 
        name: 'appendSheet', 
        icon: 'sheets_rtl', 
        title: 'Append Sheet', 
        ignore: false,
        output: {
        },
        options: {
            spreadsheet: {
                required: true,
                placeholder: '$spreadsheet_1',
                value: ""
            },
            sheetName: {
                required: true,
                placeholder: 'Sheet3',
                value: ""
            },
        }
    },
    // awsS3
    { 
        index: 0,
        category: 'awsS3', 
        name: 'uploadS3File', 
        icon: 'upload', 
        title: 'Upload S3 File', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$uploadS3File',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'awss3-xxxxxxxxxxxxxx',
                value: ""
            },
            bucketName: {
                required: true,
                placeholder: 'test',
                value: ""
            },
            filePath: {
                required: true,
                placeholder: '/tmp/fileName.pdf',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'awsS3', 
        name: 'downloadS3File', 
        icon: 'download', 
        title: 'Download S3 File', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$downloadS3File',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'awss3-xxxxxxxxxxxxxx',
                value: ""
            },
            bucketName: {
                required: true,
                placeholder: 'test',
                value: ""
            },
            filePath: {
                required: true,
                placeholder: '/data/fileName.pdf',
                value: ""
            },
        }
    },
    // ftp
    { 
        index: 0,
        category: 'ftp', 
        name: 'uploadFileToFTP', 
        icon: 'upload', 
        title: 'Upload File To FTP', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$uploadFtpFile',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'ftp-xxxxxxxxxxxxxx',
                value: ""
            },
            filePath: {
                required: true,
                placeholder: '/tmp/report.xlsx',
                value: ""
            },
            destinationDirectory: {
                required: false,
                placeholder: 'ftp/reports',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'ftp', 
        name: 'downloadFileFromFTP', 
        icon: 'download', 
        title: 'Download File From FTP', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$downloadFtpFile',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'ftp-xxxxxxxxxxxxxx',
                value: ""
            },
            filePath: {
                required: true,
                placeholder: 'ftp/reports/report.xlsx',
                value: ""
            },
        }
    },
    // webService
    { 
        index: 0,
        category: 'webService', 
        name: 'httpRequest', 
        icon: 'http', 
        title: 'HTTP Request', 
        ignore: false,
        output: {
            icon: 'question_mark',
            key: '$httpRequest',
            value: ""
        },
        options: {
            url: {
                required: true,
                placeholder: 'https://zipcloud.ibsnet.co.jp/api/search',
                value: ""
            },
            method: {
                required: true,
                placeholder: '',
                value: "GET"
            },
            httpHeaders: {
                required: true,
                placeholder: '{"Content-Type": "application/json"}',
                value: '{"Content-Type": "application/json"}'
            },
            params: {
                required: false,
                placeholder: '{ "zipcode": "7830060" }',
                value: ''
            },
        }
    },
    { 
        index: 0,
        category: 'webService', 
        name: 'getFileFromUrl', 
        icon: 'imagesmode', 
        title: 'Get File From URL', 
        ignore: false,
        output: {
            icon: 'title',
            key: '$getFileFromUrl',
            value: ""
        },
        options: {
            url: {
                required: true,
                placeholder: 'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png',
                value: ""
            },
            basicAuthUsername: {
                required: false,
                placeholder: 'admin',
                value: ""
            },
            basicAuthPassword: {
                required: false,
                placeholder: '123456',
                value: ""
            },
        }
    },
    // filemaker
    { 
        index: 0,
        category: 'filemaker', 
        name: 'getRecords', 
        icon: 'format_list_bulleted', 
        title: 'Get Records', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$records',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            layout: {
                required: true,
                placeholder: 'Task details',
                value: ""
            },
            parameters: {
                required: true,
                placeholder: '{ "_limit": 1 }',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'filemaker', 
        name: 'createRecord', 
        icon: 'format_list_bulleted_add', 
        title: 'Create Record', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$newRecord',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            layout: {
                required: true,
                placeholder: 'Task details',
                value: ""
            },
            fieldData: {
                required: true,
                placeholder: '{ "TaskName": "Demo" }',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'filemaker', 
        name: 'getSingleRecordById', 
        icon: 'feed', 
        title: 'Get Single Record By Id', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$singleRecord',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            layout: {
                required: true,
                placeholder: 'Task details',
                value: ""
            },
            recordID: {
                required: true,
                placeholder: '36',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'filemaker', 
        name: 'editRecord', 
        icon: 'edit_square', 
        title: 'Edit Record', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$editRecord',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            layout: {
                required: true,
                placeholder: 'Task details',
                value: ""
            },
            recordID: {
                required: true,
                placeholder: '36',
                value: ""
            },
            fieldData: {
                required: true,
                placeholder: '{ "TaskName": "Demo" }',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'filemaker', 
        name: 'deleteRecord', 
        icon: 'delete', 
        title: 'Delete Record', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$deleteRecord',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            layout: {
                required: true,
                placeholder: 'Task details',
                value: ""
            },
            recordID: {
                required: true,
                placeholder: '36',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'filemaker', 
        name: 'duplicateRecord', 
        icon: 'content_copy', 
        title: 'Duplicate Record', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$duplicateRecord',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            layout: {
                required: true,
                placeholder: 'Task details',
                value: ""
            },
            recordID: {
                required: true,
                placeholder: '36',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'filemaker', 
        name: 'findRecords', 
        icon: 'search', 
        title: 'Find Records', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$findRecords',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            layout: {
                required: true,
                placeholder: 'Task details',
                value: ""
            },
            query: {
                required: false,
                placeholder: '[{ "TaskName": "Demo", "omit": "true" }]',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'filemaker', 
        name: 'executeScript', 
        icon: 'play_circle', 
        title: 'Execute Script', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$executeScript',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            layout: {
                required: true,
                placeholder: 'Task details',
                value: ""
            },
            scriptName: {
                required: true,
                placeholder: 'Task export script',
                value: ""
            },
            params: {
                required: false,
                placeholder: '',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'filemaker', 
        name: 'uploadToContainerField', 
        icon: 'cloud_upload', 
        title: 'Upload To Container Field', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$uploadToContainerField',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            layout: {
                required: true,
                placeholder: 'Task details',
                value: ""
            },
            recordID: {
                required: true,
                placeholder: '36',
                value: ""
            },
            containerFieldname: {
                required: true,
                placeholder: 'Attachment',
                value: ""
            },
            filePath: {
                required: false,
                placeholder: '/tm/file-name.pdf',
                value: ""
            },
        }
    },
    { 
        index: 0,
        category: 'filemaker', 
        name: 'setGlobalFields', 
        icon: 'public', 
        title: 'Set Global Fields', 
        ignore: false,
        output: {
            icon: 'data_object',
            key: '$setGlobalFields',
            value: ""
        },
        options: {
            providerID: {
                required: true,
                placeholder: 'filemaker-xxxxxxxxxxxxxx',
                value: ""
            },
            globalFields: {
                required: true,
                placeholder: '{ "Table::FieldName": "value" }',
                value: ""
            },
        }
    },
    // control
    { 
        index: 0,
        category: 'control', 
        name: 'if', 
        icon: 'call_split', 
        title: 'If', 
        ignore: false,
        output: {
            icon: '',
            key: '$if',
            value: ""
        },
        options: {
            condition: {
                required: true,
                placeholder: 'fx($currentTime < 20)',
                value: "fx()"
            }
        }
    },
    { 
        index: 0,
        category: 'control', 
        name: 'else', 
        icon: 'call_split', 
        title: 'Else', 
        ignore: false,
        output: {
            icon: '',
            key: '',
            value: ""
        },
        options: {
        }
    },
    { 
        index: 0,
        category: 'control', 
        name: 'endif', 
        icon: 'call_split', 
        title: 'End If', 
        ignore: false,
        output: {
            icon: '',
            key: '',
            value: ""
        },
        options: {
        }
    },
    { 
        index: 0,
        category: 'control', 
        name: 'loop', 
        icon: 'cached', 
        title: 'Loop', 
        ignore: false,
        output: {
            icon: 'numbers',
            key: '$i',
            value: ""
        },
        options: {
            times: {
                required: true,
                placeholder: '3',
                value: ""
            },
        },
    },
    { 
        index: 0,
        category: 'control', 
        name: 'endloop', 
        icon: 'cached', 
        title: 'End Loop', 
        ignore: false,
        output: {
            icon: '',
            key: '',
            value: ""
        },
        options: {
        },
    },
    { 
        index: 0,
        category: 'control', 
        name: 'foreach', 
        icon: 'repeat', 
        title: 'ForEarch', 
        ignore: false,
        output: {
            icon: 'question_mark',
            key: '$item',
            value: ""
        },
        options: {
            iterable: {
                required: true,
                placeholder: '["red", "green", "blue"]',
                value: ""
            },
        },
    },
    { 
        index: 0,
        category: 'control', 
        name: 'endforeach', 
        icon: 'repeat', 
        title: 'End ForEarch', 
        ignore: false,
        output: {
            icon: '',
            key: '',
            value: ""
        },
        options: {
        },
    },
    { 
        index: 0,
        category: 'control', 
        name: 'breakif', 
        icon: 'do_not_disturb_alt', 
        title: 'Break If', 
        ignore: false,
        output: {
            icon: '',
            key: '$breakIf',
            value: ""
        },
        options: {
            condition: {
                required: true,
                placeholder: 'fx($currentTime < 20)',
                value: "fx()"
            }
        }
    },
    { 
        index: 0,
        category: 'control', 
        name: 'wait', 
        icon: 'hourglass_top', 
        title: 'Wait', 
        ignore: false,
        output: {
        },
        options: {
            timeout: {
                required: true,
                placeholder: '180000',
                value: ""
            },
        },
    },
    { 
        index: 0,
        category: 'control', 
        name: 'runJavascript', 
        icon: 'javascript', 
        title: 'Run Javascript', 
        ignore: false,
        output: {
            icon: 'question_mark',
            key: '$runJavascript',
            value: ""
        },
        options: {
            code: {
                required: true,
                placeholder: 'let a = 1; let b = 2; return a + b;',
                value: ""
            },
        },
    },
]
export default Steps;